import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-building-icon lucide-building",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 10h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 14h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 6h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 10h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 14h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 6h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 10h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 14h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 6h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 2,
			width: 16,
			height: 20,
			rx: 2
		})
	]
});
export default SvgBuilding;
